import { RvoAnimal } from '@tcc-mono/vandijk/shared/data-access/models';

/** RvoAnimal + eenmalig berekende leeftijd en kleurband. */
export type EnrichedRvoAnimal = RvoAnimal & { ageInDays: number; suggestedColorValue: string | null };
